import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import axios from 'axios';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { Row, Col } from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';

import Loader from '../../../Loader';
import DdKurikulum from './master/DdKurikulum';
import DdKelas from './master/DdKelas';
import DdMapel from './master/DdMapel';
import DdBab from './master/DdBab';


class MigrasiBab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            cariSoal: false,
            loading: false,
            namaKurikulum : null,
            idTipe : null,
            idKurikulum : null,
            idKelas : null,
            idMapel : null,
            idBab : null,
            idSubBab : null,
            kurikulum : [],
            kelas : [],
            mapel : [],
            bab : [],
            subBab : []
        }
        // this.fetchKelas = this.fetchKelas.bind(this);
    }
    loading = () =>{
        if(this.state.cariSoal){
            return(
                <Loader />
            )
        }
    }

    async componentDidMount() {
        document.title = "Migrasi Bab";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.fetchKurikulum();
            this.fetchKelas();
        }
        
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
        });

        window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        });

        this.setState({
            isFetching: false
        });
    }

    fetchKurikulum = async () => {
        const resKuri = await accountManagement.get(CONFIG.MIGRASI_V1_KURIKULUM)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resKuri.request.readyState === 4 && resKuri.status === 200) {
            if(resKuri.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kurikulum: resKuri.data.data.dataKurikulum
                })
            }
        }
    }
    
    kurikulumOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        
        var idKurikulum = kode.target.value;
        this.setState({
            idKurikulum : idKurikulum,
            idKelas : null,
            idMapel : null,
            idBab : null,
            idTipe : null
        });


        this.setState({isFetching: false});
    }

    fetchKelas = async () => {
        const responseFetchKelas = await accountManagement.get(CONFIG.MIGRASI_V1_KELAS)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(responseFetchKelas.request.readyState === 4 && responseFetchKelas.status === 200) {
            if(responseFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: responseFetchKelas.data.data.dataKelas
                })
            }
        }
    }

    kelasOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        var index = kode.nativeEvent.target.selectedIndex;       
        
        var idKelas = kode.target.value;
        var namaKelas = kode.nativeEvent.target[index].text;

        this.setState({
            idKelas: idKelas,
            namaKelas : namaKelas
        });

        this.setState({
            idMapel : null,
            idBab : null,
            idTipe : null
        });
        
        this.setState({mapel:[]});
        this.setState({kategori:[]});
        this.setState({soal:[]});

        const resMapel = await accountManagement.get(CONFIG.MIGRASI_V1_MAPEL+idKelas)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resMapel.request.readyState === 4 && resMapel.status === 200) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data.dataMapel
                })
            }
        }
        this.setState({isFetching: false});
    }

    mapelOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        var index = kode.nativeEvent.target.selectedIndex;       
        
        var idMapel = kode.target.value;
        var namaMapel = kode.nativeEvent.target[index].text;

        this.setState({
            idMapel: idMapel,
            namaMapel :namaMapel
        })

        this.setState({
            idBab : null,
            idTipe : null
        });

        const resBab = await accountManagement.post(CONFIG.MIGRASI_V1_BAB,{  
            ['idMapel']: idMapel,
            ['kurikulum']: this.state.idKurikulum
        }).catch (function(error){
        })

        if(resBab.request.readyState === 4 && resBab.status === 200) {
            if(resBab.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    bab: resBab.data.data.dataMapok
                })
            }
        }
        this.setState({isFetching: false});
    }

    babOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});   
        
        this.setState({idBab: kode.target.value});
        this.setState({idTipe : null});

        this.setState({isFetching: false});
    }

    tipeOnChange = async (kode) =>{
        kode.persist();
        this.setState({isFetching: true});
        var idTipe = kode.target.value;

        if(this.state.idBab != null && this.state.kurikulum != null){
            this.setState({idTipe : idTipe});
            const resSubBab = await accountManagement.post(CONFIG.MIGRASI_V1_SUB_BAB,{  
                ['idMapok']: this.state.idBab,
                ['kurikulum']: this.state.idKurikulum,
                ['tipe']: idTipe,
            }).catch (function(error){
            })
            if(resSubBab.request.readyState === 4 && resSubBab.status === 200) {
                if(resSubBab.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        subBab: resSubBab.data.data.dataKonten
                    })
                }
            }
        }else{
            alert('please complete required field');
        }


        this.setState({isFetching: false});
    }

    pindahMateri = async (kode) =>{
        this.setState({isFetching: true});
        console.log('Proses migrasi');
        
        const migMateri = await accountManagement.post(CONFIG.MIGRASI_V1_PINDAH_MATERI,{  
            ['idMapok']: this.state.idBab,
            ['idKurikulum']: this.state.idKurikulum,
            ['tipe']: this.state.idTipe,
            ['idKelas']: this.state.idKelas,
        }).catch (function(error){
        })

        this.setState({isFetching: false});

        alert(migMateri.data.data.msg)  
    }


    pindahSoal = async (kode) =>{
        // kode.persist();
        this.setState({isFetching: true}); 
        // var idMapok = kode.target.value;

        const resPindahSoalLat = await accountManagement.post(CONFIG.MIGRASI_V1_PINDAH_SOAL_LAT,{  
            ['idMapok']: kode,
            ['idKurikulum']: this.state.idKurikulum
        }).catch (function(error){
        })

        console.log(resPindahSoalLat);
       /*  if(resPindahSoalLat.request.readyState === 4 && resPindahSoalLat.status === 200) {
            if(resPindahSoalLat.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subBab: resPindahSoalLat.data.data.dataKonten
                })
            }
        } */
        this.setState({isFetching: false});
        alert(resPindahSoalLat.data.data.msg)        
    }


    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <Row>
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idKurikulum===null? "" : this.state.idKurikulum} onChange={this.kurikulumOnChange.bind(this)} required>
                                <option value="" selected disabled>~~ Pilih Kurikulum ~~</option>
                                <DdKurikulum kurikulum={this.state.kurikulum}  />
                            </select>
                        </Col>
                        
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idKelas===null? "" : this.state.idKelas} onChange={this.kelasOnChange.bind(this)} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DdKelas kelas={this.state.kelas}  />
                            </select>
                        </Col>
                        <Col sm={4}>
                            <select className="form-control" value={this.state.idMapel===null? "" : this.state.idMapel} onChange={this.mapelOnChange.bind(this)} required>
                                <option value="" selected >~~ Pilih Mapel ~~</option>
                                <DdMapel mapel={this.state.mapel}  />
                            </select>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col sm={6}>
                            <select className="form-control" value={this.state.idBab===null? "" : this.state.idBab} onChange={this.babOnChange.bind(this)} required>
                                <option value="" selected >~~ Pilih Bab ~~</option>
                                <DdBab bab={this.state.bab}  />
                            </select>
                        </Col>
                        <Col sm={2}>
                            <select className="form-control" value={this.state.idTipe===null? "" : this.state.idTipe} onChange={this.tipeOnChange.bind(this)} required>
                                <option value="" selected >~~ Pilih Tipe ~~</option>
                                <option value="MATERI">MATERI</option>
                                <option value="LATIHAN SOAL">LATIHAN SOAL</option>
                                    
                            </select>
                        </Col>
                        <Col sm={4}>
                        {this.state.idTipe === 'MATERI' ?
                            <button className="btn btn-info" onClick={this.pindahMateri.bind(this)}> <li className="fa fa-car"> G.A.S T!pi5- tipiS !!!</li></button>
                        :<></>
                        }
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        {this.state.idTipe === null ? 
                        <></>
                        :
                        <>
                        {this.state.idTipe === 'MATERI' ? 
                            <Col>
                                <h2>MATERI</h2>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th width='10px'>No</th>
                                            <th>Judul Sub Bab/Materi</th>
                                            <th>Isi Konten</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.subBab.map((s, i) => 
                                            <tr key={i}>
                                                <td>{i+1}.</td>
                                                <td>{s.nama_sub_materi}</td>
                                                <td dangerouslySetInnerHTML={{__html: s.isi_materi}}></td>
                                            </tr>
                                        )}                            
                                    </tbody>
                                </table>
                            </Col>
                            :
                            <Col>
                                <h2>Lat Soal</h2>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th width='10px'>No</th>
                                            <th>Judul Sub Bab/Materi</th>
                                            <th>GAS</th>
                                        </tr>    
                                    </thead>
                                    <tbody>
                                        {this.state.subBab.map((s, i) => 
                                            <tr key={i}>
                                                <td>{i+1}.</td>
                                                <td>{s.nama_sub_materi}</td>
                                                <td>
                                                    <button className="btn btn-danger" onClick={(e) => this.pindahSoal(s.id_sub_materi)}> 
                                                        <li className="fa fa-rocket"> Ndang Pindah</li>
                                                    </button>
                                                </td>
                                            </tr>
                                        )}                            
                                    </tbody>
                                </table>
                            </Col> 
                        }
                        </> 
                        }
                        {/* {this.state.idTipe === 'MATERI' ? 
                        <Col>
                            <p>MATERI</p>
                        </Col>
                        :
                        <Col>
                            <p>LAT SOAL</p>
                        </Col> 
                        } */}
                    </Row>
                    

                    {this.loading()}
                        <Col>
                            {/* <table className="table">
                                <thead>
                                    <th width='10px'>No</th>
                                    <th>Topik</th>
                                    <th>Pertanyaan</th>
                                    <th>pembahasan</th>
                                </thead>
                                <tbody>
                                    {this.state.soal.map((s, i) => 
                                        <tr key={i}>
                                            <td>{i+1}.</td>
                                            <td>{s.topik}</td>
                                            <td dangerouslySetInnerHTML={{__html: s.pertanyaan}}></td>
                                            <td dangerouslySetInnerHTML={{__html: s.pembahasan_text}}></td>
                                        </tr>
                                    )}                            
                                </tbody>
                            </table> */}
                        </Col>
                    {this.loading()} 
                </div>
                
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(MigrasiBab)
